module.exports = __webpack_public_path__ + "static/media/lidcore-mockup-8.b094af4d.jpg";